export default __webpack_public_path__ + "static/careers-template-team-type-b1948053b0cb4b5a4d21f2279d608dea.svg";